// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.my-docs-container {
  padding: 20px;
}
.my-docs-container.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  color: #666;
  font-size: 16px;
}
.my-docs-container .background-uploads-notification {
  background: #f8f9fa;
  border: 1px solid #e1e8ed;
  border-radius: 8px;
  padding: 12px 16px;
  margin-bottom: 16px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}
.my-docs-container .background-uploads-notification .uploads-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}
.my-docs-container .background-uploads-notification .uploads-header .uploads-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #333;
}
.my-docs-container .background-uploads-notification .uploads-header .uploads-title svg {
  color: #007bff;
}
.my-docs-container .background-uploads-notification .uploads-header .clear-uploads-btn {
  background: transparent;
  border: none;
  color: #007bff;
  font-size: 13px;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: background 0.2s;
}
.my-docs-container .background-uploads-notification .uploads-header .clear-uploads-btn:hover {
  background: #e3f2fd;
}
.my-docs-container .background-uploads-notification .uploads-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.my-docs-container .background-uploads-notification .uploads-list .upload-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: white;
  padding: 10px 12px;
  border-radius: 6px;
  border: 1px solid #e1e8ed;
}
.my-docs-container .background-uploads-notification .uploads-list .upload-item.completed {
  border-color: #d4edda;
  background: #f1f9f3;
}
.my-docs-container .background-uploads-notification .uploads-list .upload-item.error {
  border-color: #f5c6cb;
  background: #f8d7da;
}
.my-docs-container .background-uploads-notification .uploads-list .upload-item .upload-info {
  flex: 1 1;
  min-width: 0;
}
.my-docs-container .background-uploads-notification .uploads-list .upload-item .upload-info .upload-name {
  font-size: 13px;
  font-weight: 500;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 4px;
}
.my-docs-container .background-uploads-notification .uploads-list .upload-item .upload-info .upload-progress-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
  height: 20px;
  background: #e9ecef;
  border-radius: 10px;
  overflow: hidden;
}
.my-docs-container .background-uploads-notification .uploads-list .upload-item .upload-info .upload-progress-bar .upload-progress-fill {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  background: linear-gradient(90deg, #007bff, #0056b3);
  transition: width 0.3s ease;
  border-radius: 10px;
}
.my-docs-container .background-uploads-notification .uploads-list .upload-item .upload-info .upload-progress-bar .upload-progress-text {
  position: relative;
  z-index: 1;
  font-size: 11px;
  font-weight: 600;
  color: #333;
  margin-left: 8px;
}
.my-docs-container .background-uploads-notification .uploads-list .upload-item .upload-info .upload-status {
  font-size: 12px;
  font-weight: 500;
}
.my-docs-container .background-uploads-notification .uploads-list .upload-item .upload-info .upload-status.success {
  color: #28a745;
}
.my-docs-container .background-uploads-notification .uploads-list .upload-item .upload-info .upload-status.error {
  color: #dc3545;
}
.my-docs-container .background-uploads-notification .uploads-list .upload-item .remove-upload-btn {
  background: transparent;
  border: none;
  color: #999;
  font-size: 24px;
  line-height: 1;
  cursor: pointer;
  padding: 0 4px;
  margin-left: 8px;
  transition: color 0.2s;
}
.my-docs-container .background-uploads-notification .uploads-list .upload-item .remove-upload-btn:hover {
  color: #666;
}
.my-docs-container.hierarchy .my-docs-header {
  margin-bottom: 16px;
}
.my-docs-container.hierarchy .my-docs-header .header-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}
.my-docs-container.hierarchy .my-docs-header .header-top h3 {
  margin: 0;
  font-size: 17px;
  font-weight: 600;
  color: #333;
}
.my-docs-container.hierarchy .my-docs-header .header-top .header-actions {
  display: flex;
  gap: 12px;
}
.my-docs-container.hierarchy .my-docs-header .header-top .header-actions .add-doc-btn {
  background: #f5f5f5;
  color: #333;
  border: 1px solid #ddd;
  padding: 6px 18px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.2s;
}
.my-docs-container.hierarchy .my-docs-header .header-top .header-actions .add-doc-btn:hover {
  background: #e5e5e5;
}
.my-docs-container.hierarchy .my-docs-header .header-top .header-actions .add-doc-btn.primary {
  background: var(--primary-color);
  color: white;
  border-color: var(--primary-color);
}
.my-docs-container.hierarchy .my-docs-header .header-top .header-actions .add-doc-btn.primary:hover {
  background: #0052a3;
}
.my-docs-container.hierarchy .my-docs-header .info-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background: #f8f9fa;
  border-radius: 4px;
  font-size: 13px;
  color: #666;
}
.my-docs-container.hierarchy .my-docs-header .info-bar .total-items {
  font-weight: 500;
}
.my-docs-container.hierarchy .my-docs-header .info-bar .selected-info {
  color: #0066cc;
  font-weight: 500;
}
.my-docs-container.hierarchy .documents-tree {
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
}
.my-docs-container.hierarchy .documents-tree .no-documents {
  text-align: center;
  padding: 60px 20px;
  color: #666;
}
.my-docs-container.hierarchy .documents-tree .no-documents p {
  font-size: 16px;
  margin: 0 0 20px 0;
}
.my-docs-container.hierarchy .documents-tree .no-documents .add-first-doc-btn {
  background: var(--primary-color);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.2s;
}
.my-docs-container.hierarchy .documents-tree .no-documents .add-first-doc-btn:hover {
  background: #0052a3;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-header {
  display: grid;
  grid-template-columns: 1fr 120px 100px 120px;
  gap: 16px;
  padding: 12px 16px;
  background: #f8f9fa;
  border-bottom: 1px solid #e0e0e0;
  font-size: 12px;
  font-weight: 600;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-header .tree-column.name-column {
  text-align: left;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-header .tree-column.date-column, .my-docs-container.hierarchy .documents-tree .tree-container .tree-header .tree-column.size-column {
  text-align: center;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-header .tree-column.actions-column {
  text-align: right;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content {
  display: grid;
  grid-template-columns: 1fr 120px 100px 120px;
  gap: 16px;
  padding: 8px 16px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  transition: all 0.2s;
  align-items: center;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content:hover {
  background-color: #f8f9fa;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content.selected {
  background-color: #e3f2fd;
  border-color: #bbdefb;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content.folder .tree-item-left .item-name {
  font-weight: 600;
  color: #333;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content.file .tree-item-left .item-name {
  font-weight: 500;
  color: #555;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-left {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-left .expand-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  cursor: pointer;
  color: #666;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-left .expand-icon:hover {
  color: #333;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-left .file-icon {
  flex-shrink: 0;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-left .file-icon.folder-icon {
  color: #0066cc;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-left .file-icon.pdf-icon {
  color: #dc2626;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-left .file-icon.doc-icon {
  color: #2563eb;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-left .file-icon.excel-icon {
  color: #10b981;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-left .file-icon.image-icon {
  color: #8b5cf6;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-left .file-icon.default-icon {
  color: #6b7280;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-left .file-preview-container {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-left .file-preview-container.folder .file-icon.folder-icon {
  color: #0066cc;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-left .file-preview-container.image {
  border-radius: 4px;
  overflow: hidden;
  background: #f8f9fa;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-left .file-preview-container.image .image-thumbnail {
  width: 24px;
  height: 24px;
  object-fit: cover;
  border-radius: 4px;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-left .file-preview-container.image .fallback-icon {
  color: #8b5cf6;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-left .file-preview-container.file .file-icon.pdf-icon {
  color: #dc2626;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-left .file-preview-container.file .file-icon.doc-icon {
  color: #2563eb;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-left .file-preview-container.file .file-icon.excel-icon {
  color: #10b981;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-left .file-preview-container.file .file-icon.default-icon {
  color: #6b7280;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-left .item-name {
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-right {
  display: contents;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-right .item-date {
  font-size: 13px;
  color: #666;
  text-align: center;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-right .item-size {
  font-size: 13px;
  color: #666;
  text-align: center;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-right .item-actions {
  display: flex;
  justify-content: flex-end;
  gap: 4px;
  transition: opacity 0.2s;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-right .item-actions .action-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
  background: transparent;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-right .item-actions .action-btn:hover {
  background: rgba(0, 0, 0, 0.05);
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-right .item-actions .action-btn.download-btn {
  color: #059669;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-right .item-actions .action-btn.download-btn:hover {
  background: #ecfdf5;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-right .item-actions .action-btn.move-btn {
  color: #d97706;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-right .item-actions .action-btn.move-btn:hover {
  background: #fef3c7;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-right .item-actions .action-btn.delete-btn {
  color: #dc2626;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-right .item-actions .action-btn.delete-btn:hover {
  background: #fee2e2;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-children {
  background: rgba(0, 0, 0, 0.01);
}
.my-docs-container .modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}
.my-docs-container .modal-backdrop .modal {
  background: white;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
  max-height: 80vh;
  overflow-y: auto;
}
.my-docs-container .modal-backdrop .modal .modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #e0e0e0;
}
.my-docs-container .modal-backdrop .modal .modal-header h3 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #333;
}
.my-docs-container .modal-backdrop .modal .modal-header .close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.25rem;
  transition: all 0.2s;
}
.my-docs-container .modal-backdrop .modal .modal-header .close-btn:hover {
  color: #333;
  background: #f5f5f5;
}
.my-docs-container .modal-backdrop .modal .add-doc-form {
  padding: 20px;
}
.my-docs-container .modal-backdrop .modal .add-doc-form .form-group {
  margin-bottom: 20px;
}
.my-docs-container .modal-backdrop .modal .add-doc-form .form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #333;
  font-size: 14px;
}
.my-docs-container .modal-backdrop .modal .add-doc-form .form-group input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  transition: border-color 0.2s;
  box-sizing: border-box;
}
.my-docs-container .modal-backdrop .modal .add-doc-form .form-group input:focus {
  outline: none;
  border-color: #0066cc;
  box-shadow: 0 0 0 3px rgba(0, 102, 204, 0.1);
}
.my-docs-container .modal-backdrop .modal .add-doc-form .form-group input.court-ref-input, .my-docs-container .modal-backdrop .modal .add-doc-form .form-group input.location-input {
  background: #f9f9f9;
  color: #666;
  cursor: not-allowed;
}
.my-docs-container .modal-backdrop .modal .add-doc-form .form-group input.folder-name-input {
  background: white;
}
.my-docs-container .modal-backdrop .modal .add-doc-form .modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #e0e0e0;
}
.my-docs-container .modal-backdrop .modal .add-doc-form .modal-actions button {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.2s;
}
.my-docs-container .modal-backdrop .modal .add-doc-form .modal-actions button.cancel-btn {
  background: #f5f5f5;
  color: #666;
  border: 1px solid #ddd;
}
.my-docs-container .modal-backdrop .modal .add-doc-form .modal-actions button.cancel-btn:hover {
  background: #e0e0e0;
}
.my-docs-container .modal-backdrop .modal .add-doc-form .modal-actions button.submit-btn {
  background: #0066cc;
  color: white;
}
.my-docs-container .modal-backdrop .modal .add-doc-form .modal-actions button.submit-btn:hover:not(:disabled) {
  background: #0052a3;
}
.my-docs-container .modal-backdrop .modal .add-doc-form .modal-actions button.submit-btn:disabled {
  background: #ccc;
  cursor: not-allowed;
  opacity: 0.7;
}
.my-docs-container .modal-backdrop .modal .move-options {
  padding: 20px;
}
.my-docs-container .modal-backdrop .modal .move-options p {
  margin: 0 0 16px 0;
  font-weight: 500;
  color: #333;
}
.my-docs-container .modal-backdrop .modal .move-options .move-option {
  width: 100%;
  padding: 12px 16px;
  background: #f8f9fa;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  color: #333;
  margin-bottom: 8px;
  transition: all 0.2s;
  text-align: left;
}
.my-docs-container .modal-backdrop .modal .move-options .move-option:hover {
  background: #e9ecef;
  border-color: #0066cc;
}
.my-docs-container .modal-backdrop .modal .move-options .modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid #e0e0e0;
}
.my-docs-container .modal-backdrop .modal .move-options .modal-actions button {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.2s;
}
.my-docs-container .modal-backdrop .modal .move-options .modal-actions button.cancel-btn {
  background: #f5f5f5;
  color: #666;
  border: 1px solid #ddd;
}
.my-docs-container .modal-backdrop .modal .move-options .modal-actions button.cancel-btn:hover {
  background: #e0e0e0;
}

@media (max-width: 1024px) {
  .my-docs-container.hierarchy .documents-tree .tree-container .tree-header,
  .my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content {
    grid-template-columns: 1fr 80px 60px 80px;
    gap: 8px;
  }
  .my-docs-container.hierarchy .documents-tree .tree-container .tree-header .tree-column,
  .my-docs-container.hierarchy .documents-tree .tree-container .tree-header .item-date,
  .my-docs-container.hierarchy .documents-tree .tree-container .tree-header .item-size,
  .my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-column,
  .my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .item-date,
  .my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .item-size {
    font-size: 11px;
  }
}
@media (max-width: 768px) {
  .my-docs-container.hierarchy {
    padding: 16px;
  }
  .my-docs-container.hierarchy .my-docs-header .header-top {
    flex-direction: column;
    gap: 12px;
    align-items: stretch;
  }
  .my-docs-container.hierarchy .my-docs-header .header-top .header-actions {
    justify-content: stretch;
  }
  .my-docs-container.hierarchy .my-docs-header .header-top .header-actions .add-doc-btn {
    flex: 1 1;
    justify-content: center;
    padding: 10px 16px;
    font-size: 14px;
  }
  .my-docs-container.hierarchy .my-docs-header .info-bar {
    flex-direction: column;
    gap: 4px;
    align-items: flex-start;
  }
  .my-docs-container.hierarchy .documents-tree .tree-container .tree-header {
    display: none;
  }
  .my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
    padding: 12px 16px;
  }
  .my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-left .item-name {
    font-size: 15px;
  }
  .my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-right {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-right .item-date,
  .my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-right .item-size {
    font-size: 12px;
  }
  .my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-right .item-actions {
    opacity: 1;
  }
  .my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-right .item-actions .action-btn {
    width: 32px;
    height: 32px;
  }
  .my-docs-container.hierarchy .modal-backdrop .modal {
    width: 95%;
    margin: 20px;
    max-height: 90vh;
  }
  .my-docs-container.hierarchy .modal-backdrop .modal .add-doc-form .modal-actions {
    flex-direction: column;
  }
  .my-docs-container.hierarchy .modal-backdrop .modal .add-doc-form .modal-actions button {
    width: 100%;
  }
}
.loading-spinner {
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid #f3f3f3;
  border-top: 2px solid #0066cc;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.file-type-indicator.pdf {
  color: #dc2626;
}
.file-type-indicator.word {
  color: #2563eb;
}
.file-type-indicator.excel {
  color: #10b981;
}
.file-type-indicator.image {
  color: #8b5cf6;
}
.file-type-indicator.folder {
  color: #0066cc;
}

.info-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background: #f8f9fa;
  border-radius: 4px;
  font-size: 13px;
  color: #666;
}
.info-bar .breadcrumb {
  display: flex;
  align-items: center;
  gap: 6px;
}
.info-bar .breadcrumb .breadcrumb-item {
  display: flex;
  align-items: center;
  gap: 4px;
  background: none;
  border: none;
  color: #666;
  font-size: 13px;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: all 0.2s;
}
.info-bar .breadcrumb .breadcrumb-item:hover {
  background: #e9ecef;
  color: #333;
}
.info-bar .breadcrumb .breadcrumb-item.active {
  color: #0066cc;
  font-weight: 500;
  cursor: default;
}
.info-bar .breadcrumb .breadcrumb-item.active:hover {
  background: transparent;
}
.info-bar .breadcrumb > svg {
  color: #999;
  flex-shrink: 0;
}
.info-bar .total-items {
  font-weight: 500;
  white-space: nowrap;
}

.location-input-container {
  position: relative;
  display: flex;
  align-items: center;
}
.location-input-container > svg {
  position: absolute;
  left: 10px;
  color: #666;
  z-index: 1;
}
.location-input-container .location-input {
  padding-left: 32px !important;
  padding-right: 40px !important;
}
.location-input-container .root-btn {
  position: absolute;
  right: 8px;
  background: none;
  border: none;
  color: #0066cc;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}
.location-input-container .root-btn:hover {
  background: #f0f8ff;
  color: #0052a3;
}

.upload-section .file-input {
  width: 100%;
  padding: 10px 12px;
  border: 2px dashed #ddd;
  border-radius: 6px;
  background: #fafafa;
  cursor: pointer;
  transition: all 0.2s;
}
.upload-section .file-input:hover {
  border-color: #0066cc;
  background: #f8fbff;
}
.upload-section .file-input:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}
.upload-section .upload-progress {
  margin-top: 12px;
  padding: 12px;
  background: #f8f9fa;
  border-radius: 6px;
  border: 1px solid #e9ecef;
}
.upload-section .upload-progress .progress-bar {
  width: 100%;
  height: 8px;
  background: #e9ecef;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 8px;
}
.upload-section .upload-progress .progress-bar .progress {
  height: 100%;
  background: linear-gradient(90deg, #0066cc, #4a9eff);
  border-radius: 4px;
  transition: width 0.3s ease;
}
.upload-section .upload-progress span {
  font-size: 12px;
  color: #666;
  font-weight: 500;
}
.upload-section .uploaded-file-preview {
  margin-top: 12px;
  padding: 12px;
  background: #f0f8ff;
  border: 1px solid #cce7ff;
  border-radius: 6px;
}
.upload-section .uploaded-file-preview .file-info {
  display: flex;
  align-items: center;
  gap: 8px;
}
.upload-section .uploaded-file-preview .file-info svg {
  color: #0066cc;
  flex-shrink: 0;
}
.upload-section .uploaded-file-preview .file-info span {
  flex: 1 1;
  font-size: 14px;
  color: #333;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.upload-section .uploaded-file-preview .file-info .cancel-upload-button {
  background: none;
  border: none;
  color: #dc2626;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  padding: 2px 6px;
  border-radius: 4px;
  transition: all 0.2s;
  line-height: 1;
}
.upload-section .uploaded-file-preview .file-info .cancel-upload-button:hover {
  background: #fee2e2;
}

@media (max-width: 768px) {
  .info-bar {
    flex-direction: column;
    gap: 8px;
    align-items: flex-start;
  }
  .info-bar .breadcrumb .breadcrumb-item {
    font-size: 12px;
    padding: 3px 6px;
  }
  .info-bar .total-items {
    font-size: 12px;
  }
  .location-input-container .location-input {
    padding-left: 28px !important;
    padding-right: 36px !important;
  }
  .location-input-container > svg {
    left: 8px;
    width: 14px;
    height: 14px;
  }
  .location-input-container .root-btn {
    right: 6px;
    padding: 3px;
  }
  .location-input-container .root-btn svg {
    width: 12px;
    height: 12px;
  }
  .upload-section .file-input {
    padding: 8px 10px;
    font-size: 14px;
  }
  .upload-section .upload-progress {
    padding: 10px;
  }
  .upload-section .upload-progress .progress-bar {
    height: 6px;
  }
  .upload-section .upload-progress span {
    font-size: 11px;
  }
  .upload-section .uploaded-file-preview {
    padding: 10px;
  }
  .upload-section .uploaded-file-preview .file-info {
    gap: 6px;
  }
  .upload-section .uploaded-file-preview .file-info svg {
    width: 14px;
    height: 14px;
  }
  .upload-section .uploaded-file-preview .file-info span {
    font-size: 13px;
  }
  .upload-section .uploaded-file-preview .file-info .cancel-upload-button {
    font-size: 16px;
    padding: 1px 4px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/TabViewer/RenderMyDocs.scss"],"names":[],"mappings":"AACA;EACI,aAAA;AAAJ;AAGI;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;EACA,eAAA;AADR;AAKI;EACI,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yCAAA;AAHR;AAKQ;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAHZ;AAKY;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AAHhB;AAKgB;EACI,cAAA;AAHpB;AAOY;EACI,uBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,2BAAA;AALhB;AAOgB;EACI,mBAAA;AALpB;AAUQ;EACI,aAAA;EACA,sBAAA;EACA,QAAA;AARZ;AAUY;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;AARhB;AAUgB;EACI,qBAAA;EACA,mBAAA;AARpB;AAWgB;EACI,qBAAA;EACA,mBAAA;AATpB;AAYgB;EACI,SAAA;EACA,YAAA;AAVpB;AAYoB;EACI,eAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;AAVxB;AAaoB;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AAXxB;AAawB;EACI,kBAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;EACA,oDAAA;EACA,2BAAA;EACA,mBAAA;AAX5B;AAcwB;EACI,kBAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;AAZ5B;AAgBoB;EACI,eAAA;EACA,gBAAA;AAdxB;AAgBwB;EACI,cAAA;AAd5B;AAiBwB;EACI,cAAA;AAf5B;AAoBgB;EACI,uBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,sBAAA;AAlBpB;AAoBoB;EACI,WAAA;AAlBxB;AA0BQ;EACI,mBAAA;AAxBZ;AA2BY;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAzBhB;AA4BgB;EACI,SAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AA1BpB;AA8BgB;EACI,aAAA;EACA,SAAA;AA5BpB;AA+BoB;EACI,mBAAA;EACA,WAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,oBAAA;AA7BxB;AAgCwB;EACI,mBAAA;AA9B5B;AAkCwB;EACI,gCAAA;EACA,YAAA;EACA,kCAAA;AAhC5B;AAmC4B;EACI,mBAAA;AAjChC;AAyCY;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;AAvChB;AA0CgB;EACI,gBAAA;AAxCpB;AA4CgB;EACI,cAAA;EACA,gBAAA;AA1CpB;AAgDQ;EACI,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AA9CZ;AAiDY;EACI,kBAAA;EACA,kBAAA;EACA,WAAA;AA/ChB;AAkDgB;EACI,eAAA;EACA,kBAAA;AAhDpB;AAoDgB;EACI,gCAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,iCAAA;AAlDpB;AAqDoB;EACI,mBAAA;AAnDxB;AA0DgB;EACI,aAAA;EACA,4CAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,yBAAA;EACA,qBAAA;AAxDpB;AA4DwB;EACI,gBAAA;AA1D5B;AA6DwB;EAEI,kBAAA;AA5D5B;AAgEwB;EACI,iBAAA;AA9D5B;AAsEwB;EACI,aAAA;EACA,4CAAA;EACA,SAAA;EACA,iBAAA;EACA,gCAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;AApE5B;AAuE4B;EACI,yBAAA;AArEhC;AAyE4B;EACI,yBAAA;EACA,qBAAA;AAvEhC;AA4EgC;EACI,gBAAA;EACA,WAAA;AA1EpC;AAgFgC;EACI,gBAAA;EACA,WAAA;AA9EpC;AAmF4B;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;AAjFhC;AAoFgC;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;AAlFpC;AAoFoC;EACI,WAAA;AAlFxC;AAuFgC;EACI,cAAA;AArFpC;AAuFoC;EACI,cAAA;AArFxC;AAwFoC;EACI,cAAA;AAtFxC;AAyFoC;EACI,cAAA;AAvFxC;AA0FoC;EACI,cAAA;AAxFxC;AA2FoC;EACI,cAAA;AAzFxC;AA4FoC;EACI,cAAA;AA1FxC;AA+FgC;EACI,cAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AA7FpC;AAkG4C;EACI,cAAA;AAhGhD;AAsGoC;EACI,kBAAA;EACA,gBAAA;EACA,mBAAA;AApGxC;AAuGwC;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AArG5C;AAyGwC;EACI,cAAA;AAvG5C;AA8G4C;EACI,cAAA;AA5GhD;AA+G4C;EACI,cAAA;AA7GhD;AAgH4C;EACI,cAAA;AA9GhD;AAiH4C;EACI,cAAA;AA/GhD;AAsHgC;EACI,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AApHpC;AAyH4B;EACI,iBAAA;AAvHhC;AA0HgC;EACI,eAAA;EACA,WAAA;EACA,kBAAA;AAxHpC;AA4HgC;EACI,eAAA;EACA,WAAA;EACA,kBAAA;AA1HpC;AA8HgC;EACI,aAAA;EACA,yBAAA;EACA,QAAA;EACA,wBAAA;AA5HpC;AA+HoC;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;EACA,uBAAA;AA7HxC;AAgIwC;EACI,+BAAA;AA9H5C;AAkIwC;EACI,cAAA;AAhI5C;AAkI4C;EACI,mBAAA;AAhIhD;AAqIwC;EACI,cAAA;AAnI5C;AAqI4C;EACI,mBAAA;AAnIhD;AAwIwC;EACI,cAAA;AAtI5C;AAwI4C;EACI,mBAAA;AAtIhD;AAiJwB;EACI,+BAAA;AA/I5B;AAyJI;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AAvJR;AA0JQ;EACI,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AAxJZ;AA2JY;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,gCAAA;AAzJhB;AA4JgB;EACI,SAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AA1JpB;AA8JgB;EACI,gBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,oBAAA;AA5JpB;AAgKoB;EACI,WAAA;EACA,mBAAA;AA9JxB;AAoKY;EACI,aAAA;AAlKhB;AAqKgB;EACI,mBAAA;AAnKpB;AAsKoB;EACI,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;AApKxB;AAwKoB;EACI,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,6BAAA;EACA,sBAAA;AAtKxB;AAyKwB;EACI,aAAA;EACA,qBAAA;EACA,4CAAA;AAvK5B;AA2KwB;EAEI,mBAAA;EACA,WAAA;EACA,mBAAA;AA1K5B;AA8KwB;EACI,iBAAA;AA5K5B;AAkLgB;EACI,aAAA;EACA,yBAAA;EACA,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,6BAAA;AAhLpB;AAmLoB;EACI,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,iCAAA;AAjLxB;AAoLwB;EACI,mBAAA;EACA,WAAA;EACA,sBAAA;AAlL5B;AAqL4B;EACI,mBAAA;AAnLhC;AAwLwB;EACI,mBAAA;EACA,YAAA;AAtL5B;AAyL4B;EACI,mBAAA;AAvLhC;AA2L4B;EACI,gBAAA;EACA,mBAAA;EACA,YAAA;AAzLhC;AAiMY;EACI,aAAA;AA/LhB;AAkMgB;EACI,kBAAA;EACA,gBAAA;EACA,WAAA;AAhMpB;AAoMgB;EACI,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;EACA,oBAAA;EACA,gBAAA;AAlMpB;AAqMoB;EACI,mBAAA;EACA,qBAAA;AAnMxB;AAwMgB;EACI,aAAA;EACA,yBAAA;EACA,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,6BAAA;AAtMpB;AAyMoB;EACI,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,iCAAA;AAvMxB;AA0MwB;EACI,mBAAA;EACA,WAAA;EACA,sBAAA;AAxM5B;AA2M4B;EACI,mBAAA;AAzMhC;;AAqNA;EAGY;;IAEI,yCAAA;IACA,QAAA;EApNd;EAuNc;;;;;;IAGI,eAAA;EAlNlB;AACF;AAyNA;EACI;IACI,aAAA;EAvNN;EA2NU;IACI,sBAAA;IACA,SAAA;IACA,oBAAA;EAzNd;EA4Nc;IACI,wBAAA;EA1NlB;EA6NkB;IACI,SAAA;IACA,uBAAA;IACA,kBAAA;IACA,eAAA;EA3NtB;EAiOU;IACI,sBAAA;IACA,QAAA;IACA,uBAAA;EA/Nd;EAqOU;IACI,aAAA;EAnOd;EAuOU;IACI,aAAA;IACA,sBAAA;IACA,oBAAA;IACA,QAAA;IACA,kBAAA;EArOd;EAyOkB;IACI,eAAA;EAvOtB;EA4Oc;IACI,aAAA;IACA,8BAAA;IACA,mBAAA;EA1OlB;EA6OkB;;IAEI,eAAA;EA3OtB;EA+OkB;IACI,UAAA;EA7OtB;EA+OsB;IACI,WAAA;IACA,YAAA;EA7O1B;EAqPM;IACI,UAAA;IACA,YAAA;IACA,gBAAA;EAnPV;EAsPU;IACI,sBAAA;EApPd;EAsPc;IACI,WAAA;EApPlB;AACF;AA4PA;EACI,qBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,6BAAA;EACA,kBAAA;EACA,kCAAA;AA1PJ;;AA8PA;EACI;IAAK,uBAAA;EA1PP;EA2PE;IAAO,yBAAA;EAxPT;AACF;AA6PI;EAAQ,cAAA;AA1PZ;AA2PI;EAAS,cAAA;AAxPb;AAyPI;EAAU,cAAA;AAtPd;AAuPI;EAAU,cAAA;AApPd;AAqPI;EAAW,cAAA;AAlPf;;AA0PA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;AAvPJ;AA0PI;EACI,aAAA;EACA,mBAAA;EACA,QAAA;AAxPR;AA2PQ;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;AAzPZ;AA4PY;EACI,mBAAA;EACA,WAAA;AA1PhB;AA8PY;EACI,cAAA;EACA,gBAAA;EACA,eAAA;AA5PhB;AA+PgB;EACI,uBAAA;AA7PpB;AAoQQ;EACI,WAAA;EACA,cAAA;AAlQZ;AAuQI;EACI,gBAAA;EACA,mBAAA;AArQR;;AA2QA;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;AAxQJ;AA2QI;EACI,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;AAzQR;AA6QI;EACI,6BAAA;EACA,8BAAA;AA3QR;AA+QI;EACI,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;AA7QR;AAgRQ;EACI,mBAAA;EACA,cAAA;AA9QZ;;AAsRI;EACI,WAAA;EACA,kBAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;AAnRR;AAqRQ;EACI,qBAAA;EACA,mBAAA;AAnRZ;AAuRQ;EACI,mBAAA;EACA,YAAA;AArRZ;AA0RI;EACI,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;AAxRR;AA2RQ;EACI,WAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AAzRZ;AA4RY;EACI,YAAA;EACA,oDAAA;EACA,kBAAA;EACA,2BAAA;AA1RhB;AA+RQ;EACI,eAAA;EACA,WAAA;EACA,gBAAA;AA7RZ;AAkSI;EACI,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AAhSR;AAmSQ;EACI,aAAA;EACA,mBAAA;EACA,QAAA;AAjSZ;AAoSY;EACI,cAAA;EACA,cAAA;AAlShB;AAsSY;EACI,SAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AApShB;AAwSY;EACI,gBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,cAAA;AAtShB;AAySgB;EACI,mBAAA;AAvSpB;;AAgTA;EACI;IACI,sBAAA;IACA,QAAA;IACA,uBAAA;EA7SN;EAiTU;IACI,eAAA;IACA,gBAAA;EA/Sd;EAoTM;IACI,eAAA;EAlTV;EAwTM;IACI,6BAAA;IACA,8BAAA;EAtTV;EA0TM;IACI,SAAA;IACA,WAAA;IACA,YAAA;EAxTV;EA4TM;IACI,UAAA;IACA,YAAA;EA1TV;EA6TU;IACI,WAAA;IACA,YAAA;EA3Td;EAkUM;IACI,iBAAA;IACA,eAAA;EAhUV;EAoUM;IACI,aAAA;EAlUV;EAqUU;IACI,WAAA;EAnUd;EAuUU;IACI,eAAA;EArUd;EA0UM;IACI,aAAA;EAxUV;EA2UU;IACI,QAAA;EAzUd;EA4Uc;IACI,WAAA;IACA,YAAA;EA1UlB;EA8Uc;IACI,eAAA;EA5UlB;EAgVc;IACI,eAAA;IACA,gBAAA;EA9UlB;AACF","sourcesContent":["// RenderMyDocs.scss\r\n.my-docs-container {\r\n    padding: 20px;\r\n\r\n\r\n    &.loading {\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n        min-height: 200px;\r\n        color: #666;\r\n        font-size: 16px;\r\n    }\r\n\r\n    // Background Uploads Notification\r\n    .background-uploads-notification {\r\n        background: #f8f9fa;\r\n        border: 1px solid #e1e8ed;\r\n        border-radius: 8px;\r\n        padding: 12px 16px;\r\n        margin-bottom: 16px;\r\n        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\r\n\r\n        .uploads-header {\r\n            display: flex;\r\n            justify-content: space-between;\r\n            align-items: center;\r\n            margin-bottom: 12px;\r\n\r\n            .uploads-title {\r\n                display: flex;\r\n                align-items: center;\r\n                gap: 8px;\r\n                font-size: 14px;\r\n                font-weight: 600;\r\n                color: #333;\r\n\r\n                svg {\r\n                    color: #007bff;\r\n                }\r\n            }\r\n\r\n            .clear-uploads-btn {\r\n                background: transparent;\r\n                border: none;\r\n                color: #007bff;\r\n                font-size: 13px;\r\n                cursor: pointer;\r\n                padding: 4px 8px;\r\n                border-radius: 4px;\r\n                transition: background 0.2s;\r\n\r\n                &:hover {\r\n                    background: #e3f2fd;\r\n                }\r\n            }\r\n        }\r\n\r\n        .uploads-list {\r\n            display: flex;\r\n            flex-direction: column;\r\n            gap: 8px;\r\n\r\n            .upload-item {\r\n                display: flex;\r\n                justify-content: space-between;\r\n                align-items: center;\r\n                background: white;\r\n                padding: 10px 12px;\r\n                border-radius: 6px;\r\n                border: 1px solid #e1e8ed;\r\n\r\n                &.completed {\r\n                    border-color: #d4edda;\r\n                    background: #f1f9f3;\r\n                }\r\n\r\n                &.error {\r\n                    border-color: #f5c6cb;\r\n                    background: #f8d7da;\r\n                }\r\n\r\n                .upload-info {\r\n                    flex: 1;\r\n                    min-width: 0;\r\n\r\n                    .upload-name {\r\n                        font-size: 13px;\r\n                        font-weight: 500;\r\n                        color: #333;\r\n                        white-space: nowrap;\r\n                        overflow: hidden;\r\n                        text-overflow: ellipsis;\r\n                        margin-bottom: 4px;\r\n                    }\r\n\r\n                    .upload-progress-bar {\r\n                        display: flex;\r\n                        align-items: center;\r\n                        gap: 8px;\r\n                        position: relative;\r\n                        height: 20px;\r\n                        background: #e9ecef;\r\n                        border-radius: 10px;\r\n                        overflow: hidden;\r\n\r\n                        .upload-progress-fill {\r\n                            position: absolute;\r\n                            left: 0;\r\n                            top: 0;\r\n                            height: 100%;\r\n                            background: linear-gradient(90deg, #007bff, #0056b3);\r\n                            transition: width 0.3s ease;\r\n                            border-radius: 10px;\r\n                        }\r\n\r\n                        .upload-progress-text {\r\n                            position: relative;\r\n                            z-index: 1;\r\n                            font-size: 11px;\r\n                            font-weight: 600;\r\n                            color: #333;\r\n                            margin-left: 8px;\r\n                        }\r\n                    }\r\n\r\n                    .upload-status {\r\n                        font-size: 12px;\r\n                        font-weight: 500;\r\n\r\n                        &.success {\r\n                            color: #28a745;\r\n                        }\r\n\r\n                        &.error {\r\n                            color: #dc3545;\r\n                        }\r\n                    }\r\n                }\r\n\r\n                .remove-upload-btn {\r\n                    background: transparent;\r\n                    border: none;\r\n                    color: #999;\r\n                    font-size: 24px;\r\n                    line-height: 1;\r\n                    cursor: pointer;\r\n                    padding: 0 4px;\r\n                    margin-left: 8px;\r\n                    transition: color 0.2s;\r\n\r\n                    &:hover {\r\n                        color: #666;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    &.hierarchy {\r\n        .my-docs-header {\r\n            margin-bottom: 16px;\r\n\r\n\r\n            .header-top {\r\n                display: flex;\r\n                justify-content: space-between;\r\n                align-items: center;\r\n                margin-bottom: 12px;\r\n\r\n\r\n                h3 {\r\n                    margin: 0;\r\n                    font-size: 17px;\r\n                    font-weight: 600;\r\n                    color: #333;\r\n                }\r\n\r\n\r\n                .header-actions {\r\n                    display: flex;\r\n                    gap: 12px;\r\n\r\n\r\n                    .add-doc-btn {\r\n                        background: #f5f5f5;\r\n                        color: #333;\r\n                        border: 1px solid #ddd;\r\n                        padding: 6px 18px;\r\n                        border-radius: 6px;\r\n                        cursor: pointer;\r\n                        font-size: 13px;\r\n                        font-weight: 500;\r\n                        display: flex;\r\n                        align-items: center;\r\n                        gap: 6px;\r\n                        transition: all 0.2s;\r\n\r\n\r\n                        &:hover {\r\n                            background: #e5e5e5;\r\n                        }\r\n\r\n\r\n                        &.primary {\r\n                            background: var(--primary-color);\r\n                            color: white;\r\n                            border-color: var(--primary-color);\r\n\r\n\r\n                            &:hover {\r\n                                background: #0052a3;\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n\r\n\r\n            .info-bar {\r\n                display: flex;\r\n                justify-content: space-between;\r\n                align-items: center;\r\n                padding: 8px 12px;\r\n                background: #f8f9fa;\r\n                border-radius: 4px;\r\n                font-size: 13px;\r\n                color: #666;\r\n\r\n\r\n                .total-items {\r\n                    font-weight: 500;\r\n                }\r\n\r\n\r\n                .selected-info {\r\n                    color: #0066cc;\r\n                    font-weight: 500;\r\n                }\r\n            }\r\n        }\r\n\r\n\r\n        .documents-tree {\r\n            background: white;\r\n            border: 1px solid #e0e0e0;\r\n            border-radius: 8px;\r\n            overflow: hidden;\r\n\r\n\r\n            .no-documents {\r\n                text-align: center;\r\n                padding: 60px 20px;\r\n                color: #666;\r\n\r\n\r\n                p {\r\n                    font-size: 16px;\r\n                    margin: 0 0 20px 0;\r\n                }\r\n\r\n\r\n                .add-first-doc-btn {\r\n                    background: var(--primary-color);\r\n                    color: white;\r\n                    border: none;\r\n                    padding: 12px 24px;\r\n                    border-radius: 6px;\r\n                    cursor: pointer;\r\n                    font-size: 14px;\r\n                    font-weight: 500;\r\n                    transition: background-color 0.2s;\r\n\r\n\r\n                    &:hover {\r\n                        background: #0052a3;\r\n                    }\r\n                }\r\n            }\r\n\r\n\r\n            .tree-container {\r\n                .tree-header {\r\n                    display: grid;\r\n                    grid-template-columns: 1fr 120px 100px 120px;\r\n                    gap: 16px;\r\n                    padding: 12px 16px;\r\n                    background: #f8f9fa;\r\n                    border-bottom: 1px solid #e0e0e0;\r\n                    font-size: 12px;\r\n                    font-weight: 600;\r\n                    color: #666;\r\n                    text-transform: uppercase;\r\n                    letter-spacing: 0.5px;\r\n\r\n\r\n                    .tree-column {\r\n                        &.name-column {\r\n                            text-align: left;\r\n                        }\r\n                       \r\n                        &.date-column,\r\n                        &.size-column {\r\n                            text-align: center;\r\n                        }\r\n\r\n\r\n                        &.actions-column {\r\n                            text-align: right;\r\n                        }\r\n                    }\r\n                }\r\n\r\n\r\n                .tree-content {\r\n                    .tree-item {\r\n                        .tree-item-content {\r\n                            display: grid;\r\n                            grid-template-columns: 1fr 120px 100px 120px;\r\n                            gap: 16px;\r\n                            padding: 8px 16px;\r\n                            border-bottom: 1px solid #f0f0f0;\r\n                            cursor: pointer;\r\n                            transition: all 0.2s;\r\n                            align-items: center;\r\n\r\n\r\n                            &:hover {\r\n                                background-color: #f8f9fa;\r\n                            }\r\n\r\n\r\n                            &.selected {\r\n                                background-color: #e3f2fd;\r\n                                border-color: #bbdefb;\r\n                            }\r\n\r\n\r\n                            &.folder {\r\n                                .tree-item-left .item-name {\r\n                                    font-weight: 600;\r\n                                    color: #333;\r\n                                }\r\n                            }\r\n\r\n\r\n                            &.file {\r\n                                .tree-item-left .item-name {\r\n                                    font-weight: 500;\r\n                                    color: #555;\r\n                                }\r\n                            }\r\n\r\n\r\n                            .tree-item-left {\r\n                                display: flex;\r\n                                align-items: center;\r\n                                gap: 8px;\r\n                                min-width: 0;\r\n\r\n\r\n                                .expand-icon {\r\n                                    display: flex;\r\n                                    align-items: center;\r\n                                    justify-content: center;\r\n                                    width: 16px;\r\n                                    height: 16px;\r\n                                    cursor: pointer;\r\n                                    color: #666;\r\n                                   \r\n                                    &:hover {\r\n                                        color: #333;\r\n                                    }\r\n                                }\r\n\r\n\r\n                                .file-icon {\r\n                                    flex-shrink: 0;\r\n                                   \r\n                                    &.folder-icon {\r\n                                        color: #0066cc;\r\n                                    }\r\n                                   \r\n                                    &.pdf-icon {\r\n                                        color: #dc2626;\r\n                                    }\r\n                                   \r\n                                    &.doc-icon {\r\n                                        color: #2563eb;\r\n                                    }\r\n                                   \r\n                                    &.excel-icon {\r\n                                        color: #10b981;\r\n                                    }\r\n                                   \r\n                                    &.image-icon {\r\n                                        color: #8b5cf6;\r\n                                    }\r\n                                   \r\n                                    &.default-icon {\r\n                                        color: #6b7280;\r\n                                    }\r\n                                }\r\n\r\n\r\n                                .file-preview-container {\r\n                                    flex-shrink: 0;\r\n                                    width: 24px;\r\n                                    height: 24px;\r\n                                    display: flex;\r\n                                    align-items: center;\r\n                                    justify-content: center;\r\n                                    position: relative;\r\n\r\n\r\n                                    &.folder {\r\n                                        .file-icon {\r\n                                            &.folder-icon {\r\n                                                color: #0066cc;\r\n                                            }\r\n                                        }\r\n                                    }\r\n\r\n\r\n                                    &.image {\r\n                                        border-radius: 4px;\r\n                                        overflow: hidden;\r\n                                        background: #f8f9fa;\r\n\r\n\r\n                                        .image-thumbnail {\r\n                                            width: 24px;\r\n                                            height: 24px;\r\n                                            object-fit: cover;\r\n                                            border-radius: 4px;\r\n                                        }\r\n\r\n\r\n                                        .fallback-icon {\r\n                                            color: #8b5cf6;\r\n                                        }\r\n                                    }\r\n\r\n\r\n                                    &.file {\r\n                                        .file-icon {\r\n                                            &.pdf-icon {\r\n                                                color: #dc2626;\r\n                                            }\r\n                                           \r\n                                            &.doc-icon {\r\n                                                color: #2563eb;\r\n                                            }\r\n                                           \r\n                                            &.excel-icon {\r\n                                                color: #10b981;\r\n                                            }\r\n                                           \r\n                                            &.default-icon {\r\n                                                color: #6b7280;\r\n                                            }\r\n                                        }\r\n                                    }\r\n                                }\r\n\r\n\r\n                                .item-name {\r\n                                    font-size: 14px;\r\n                                    white-space: nowrap;\r\n                                    overflow: hidden;\r\n                                    text-overflow: ellipsis;\r\n                                }\r\n                            }\r\n\r\n\r\n                            .tree-item-right {\r\n                                display: contents;\r\n\r\n\r\n                                .item-date {\r\n                                    font-size: 13px;\r\n                                    color: #666;\r\n                                    text-align: center;\r\n                                }\r\n\r\n\r\n                                .item-size {\r\n                                    font-size: 13px;\r\n                                    color: #666;\r\n                                    text-align: center;\r\n                                }\r\n\r\n\r\n                                .item-actions {\r\n                                    display: flex;\r\n                                    justify-content: flex-end;\r\n                                    gap: 4px;\r\n                                    transition: opacity 0.2s;\r\n\r\n\r\n                                    .action-btn {\r\n                                        display: flex;\r\n                                        align-items: center;\r\n                                        justify-content: center;\r\n                                        width: 28px;\r\n                                        height: 28px;\r\n                                        border: none;\r\n                                        border-radius: 4px;\r\n                                        cursor: pointer;\r\n                                        transition: all 0.2s;\r\n                                        background: transparent;\r\n\r\n\r\n                                        &:hover {\r\n                                            background: rgba(0, 0, 0, 0.05);\r\n                                        }\r\n\r\n\r\n                                        &.download-btn {\r\n                                            color: #059669;\r\n                                           \r\n                                            &:hover {\r\n                                                background: #ecfdf5;\r\n                                            }\r\n                                        }\r\n\r\n\r\n                                        &.move-btn {\r\n                                            color: #d97706;\r\n                                           \r\n                                            &:hover {\r\n                                                background: #fef3c7;\r\n                                            }\r\n                                        }\r\n\r\n\r\n                                        &.delete-btn {\r\n                                            color: #dc2626;\r\n                                           \r\n                                            &:hover {\r\n                                                background: #fee2e2;\r\n                                            }\r\n                                        }\r\n                                    }\r\n                                }\r\n                            }\r\n\r\n\r\n                        }\r\n\r\n\r\n                        .tree-children {\r\n                            background: rgba(0, 0, 0, 0.01);\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n\r\n    // Modal styles\r\n    .modal-backdrop {\r\n        position: fixed;\r\n        top: 0;\r\n        left: 0;\r\n        right: 0;\r\n        bottom: 0;\r\n        background: rgba(0, 0, 0, 0.5);\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n        z-index: 1000;\r\n\r\n\r\n        .modal {\r\n            background: white;\r\n            border-radius: 8px;\r\n            width: 90%;\r\n            max-width: 500px;\r\n            max-height: 80vh;\r\n            overflow-y: auto;\r\n\r\n\r\n            .modal-header {\r\n                display: flex;\r\n                justify-content: space-between;\r\n                align-items: center;\r\n                padding: 20px;\r\n                border-bottom: 1px solid #e0e0e0;\r\n\r\n\r\n                h3 {\r\n                    margin: 0;\r\n                    font-size: 20px;\r\n                    font-weight: 600;\r\n                    color: #333;\r\n                }\r\n\r\n\r\n                .close-btn {\r\n                    background: none;\r\n                    border: none;\r\n                    font-size: 24px;\r\n                    cursor: pointer;\r\n                    color: #666;\r\n                    width: 30px;\r\n                    height: 30px;\r\n                    display: flex;\r\n                    align-items: center;\r\n                    justify-content: center;\r\n                    border-radius: 0.25rem;\r\n                    transition: all 0.2s;\r\n                    \r\n\r\n\r\n                    &:hover {\r\n                        color: #333;\r\n                        background: #f5f5f5;\r\n                    }\r\n                }\r\n            }\r\n\r\n\r\n            .add-doc-form {\r\n                padding: 20px;\r\n\r\n\r\n                .form-group {\r\n                    margin-bottom: 20px;\r\n\r\n\r\n                    label {\r\n                        display: block;\r\n                        margin-bottom: 8px;\r\n                        font-weight: 500;\r\n                        color: #333;\r\n                        font-size: 14px;\r\n                    }\r\n\r\n\r\n                    input {\r\n                        width: 100%;\r\n                        padding: 10px 12px;\r\n                        border: 1px solid #ddd;\r\n                        border-radius: 4px;\r\n                        font-size: 14px;\r\n                        transition: border-color 0.2s;\r\n                        box-sizing: border-box;\r\n\r\n\r\n                        &:focus {\r\n                            outline: none;\r\n                            border-color: #0066cc;\r\n                            box-shadow: 0 0 0 3px rgba(0, 102, 204, 0.1);\r\n                        }\r\n\r\n\r\n                        &.court-ref-input,\r\n                        &.location-input {\r\n                            background: #f9f9f9;\r\n                            color: #666;\r\n                            cursor: not-allowed;\r\n                        }\r\n\r\n\r\n                        &.folder-name-input {\r\n                            background: white;\r\n                        }\r\n                    }\r\n                }\r\n\r\n\r\n                .modal-actions {\r\n                    display: flex;\r\n                    justify-content: flex-end;\r\n                    gap: 12px;\r\n                    margin-top: 24px;\r\n                    padding-top: 16px;\r\n                    border-top: 1px solid #e0e0e0;\r\n\r\n\r\n                    button {\r\n                        padding: 10px 20px;\r\n                        border: none;\r\n                        border-radius: 4px;\r\n                        cursor: pointer;\r\n                        font-size: 14px;\r\n                        font-weight: 500;\r\n                        transition: background-color 0.2s;\r\n\r\n\r\n                        &.cancel-btn {\r\n                            background: #f5f5f5;\r\n                            color: #666;\r\n                            border: 1px solid #ddd;\r\n\r\n\r\n                            &:hover {\r\n                                background: #e0e0e0;\r\n                            }\r\n                        }\r\n\r\n\r\n                        &.submit-btn {\r\n                            background: #0066cc;\r\n                            color: white;\r\n\r\n\r\n                            &:hover:not(:disabled) {\r\n                                background: #0052a3;\r\n                            }\r\n\r\n\r\n                            &:disabled {\r\n                                background: #ccc;\r\n                                cursor: not-allowed;\r\n                                opacity: 0.7;\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n\r\n\r\n            .move-options {\r\n                padding: 20px;\r\n\r\n\r\n                p {\r\n                    margin: 0 0 16px 0;\r\n                    font-weight: 500;\r\n                    color: #333;\r\n                }\r\n\r\n\r\n                .move-option {\r\n                    width: 100%;\r\n                    padding: 12px 16px;\r\n                    background: #f8f9fa;\r\n                    border: 1px solid #ddd;\r\n                    border-radius: 4px;\r\n                    cursor: pointer;\r\n                    font-size: 14px;\r\n                    color: #333;\r\n                    margin-bottom: 8px;\r\n                    transition: all 0.2s;\r\n                    text-align: left;\r\n\r\n\r\n                    &:hover {\r\n                        background: #e9ecef;\r\n                        border-color: #0066cc;\r\n                    }\r\n                }\r\n\r\n\r\n                .modal-actions {\r\n                    display: flex;\r\n                    justify-content: flex-end;\r\n                    gap: 12px;\r\n                    margin-top: 20px;\r\n                    padding-top: 16px;\r\n                    border-top: 1px solid #e0e0e0;\r\n\r\n\r\n                    button {\r\n                        padding: 10px 20px;\r\n                        border: none;\r\n                        border-radius: 4px;\r\n                        cursor: pointer;\r\n                        font-size: 14px;\r\n                        font-weight: 500;\r\n                        transition: background-color 0.2s;\r\n\r\n\r\n                        &.cancel-btn {\r\n                            background: #f5f5f5;\r\n                            color: #666;\r\n                            border: 1px solid #ddd;\r\n\r\n\r\n                            &:hover {\r\n                                background: #e0e0e0;\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n\r\n// Responsive design for hierarchy view\r\n@media (max-width: 1024px) {\r\n    .my-docs-container.hierarchy {\r\n        .documents-tree .tree-container {\r\n            .tree-header,\r\n            .tree-content .tree-item .tree-item-content {\r\n                grid-template-columns: 1fr 80px 60px 80px;\r\n                gap: 8px;\r\n\r\n\r\n                .tree-column,\r\n                .item-date,\r\n                .item-size {\r\n                    font-size: 11px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n\r\n@media (max-width: 768px) {\r\n    .my-docs-container.hierarchy {\r\n        padding: 16px;\r\n\r\n\r\n        .my-docs-header {\r\n            .header-top {\r\n                flex-direction: column;\r\n                gap: 12px;\r\n                align-items: stretch;\r\n\r\n\r\n                .header-actions {\r\n                    justify-content: stretch;\r\n\r\n\r\n                    .add-doc-btn {\r\n                        flex: 1;\r\n                        justify-content: center;\r\n                        padding: 10px 16px;\r\n                        font-size: 14px;\r\n                    }\r\n                }\r\n            }\r\n\r\n\r\n            .info-bar {\r\n                flex-direction: column;\r\n                gap: 4px;\r\n                align-items: flex-start;\r\n            }\r\n        }\r\n\r\n\r\n        .documents-tree .tree-container {\r\n            .tree-header {\r\n                display: none;\r\n            }\r\n\r\n\r\n            .tree-content .tree-item .tree-item-content {\r\n                display: flex;\r\n                flex-direction: column;\r\n                align-items: stretch;\r\n                gap: 8px;\r\n                padding: 12px 16px;\r\n\r\n\r\n                .tree-item-left {\r\n                    .item-name {\r\n                        font-size: 15px;\r\n                    }\r\n                }\r\n\r\n\r\n                .tree-item-right {\r\n                    display: flex;\r\n                    justify-content: space-between;\r\n                    align-items: center;\r\n\r\n\r\n                    .item-date,\r\n                    .item-size {\r\n                        font-size: 12px;\r\n                    }\r\n\r\n\r\n                    .item-actions {\r\n                        opacity: 1;\r\n                       \r\n                        .action-btn {\r\n                            width: 32px;\r\n                            height: 32px;\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n\r\n\r\n        .modal-backdrop .modal {\r\n            width: 95%;\r\n            margin: 20px;\r\n            max-height: 90vh;\r\n\r\n\r\n            .add-doc-form .modal-actions {\r\n                flex-direction: column;\r\n               \r\n                button {\r\n                    width: 100%;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n\r\n// Loading states\r\n.loading-spinner {\r\n    display: inline-block;\r\n    width: 16px;\r\n    height: 16px;\r\n    border: 2px solid #f3f3f3;\r\n    border-top: 2px solid #0066cc;\r\n    border-radius: 50%;\r\n    animation: spin 1s linear infinite;\r\n}\r\n\r\n\r\n@keyframes spin {\r\n    0% { transform: rotate(0deg); }\r\n    100% { transform: rotate(360deg); }\r\n}\r\n\r\n\r\n// File type indicators\r\n.file-type-indicator {\r\n    &.pdf { color: #dc2626; }\r\n    &.word { color: #2563eb; }\r\n    &.excel { color: #10b981; }\r\n    &.image { color: #8b5cf6; }\r\n    &.folder { color: #0066cc; }\r\n}\r\n\r\n\r\n// Add these styles to your existing RenderMyDocs.scss file\r\n\r\n\r\n// Breadcrumb navigation styles\r\n.info-bar {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding: 8px 12px;\r\n    background: #f8f9fa;\r\n    border-radius: 4px;\r\n    font-size: 13px;\r\n    color: #666;\r\n\r\n\r\n    .breadcrumb {\r\n        display: flex;\r\n        align-items: center;\r\n        gap: 6px;\r\n\r\n\r\n        .breadcrumb-item {\r\n            display: flex;\r\n            align-items: center;\r\n            gap: 4px;\r\n            background: none;\r\n            border: none;\r\n            color: #666;\r\n            font-size: 13px;\r\n            cursor: pointer;\r\n            padding: 4px 8px;\r\n            border-radius: 4px;\r\n            transition: all 0.2s;\r\n\r\n\r\n            &:hover {\r\n                background: #e9ecef;\r\n                color: #333;\r\n            }\r\n\r\n\r\n            &.active {\r\n                color: #0066cc;\r\n                font-weight: 500;\r\n                cursor: default;\r\n\r\n\r\n                &:hover {\r\n                    background: transparent;\r\n                }\r\n            }\r\n        }\r\n\r\n\r\n        // Chevron separator styling\r\n        > svg {\r\n            color: #999;\r\n            flex-shrink: 0;\r\n        }\r\n    }\r\n\r\n\r\n    .total-items {\r\n        font-weight: 500;\r\n        white-space: nowrap;\r\n    }\r\n}\r\n\r\n\r\n// Location input container with root button\r\n.location-input-container {\r\n    position: relative;\r\n    display: flex;\r\n    align-items: center;\r\n\r\n\r\n    > svg {\r\n        position: absolute;\r\n        left: 10px;\r\n        color: #666;\r\n        z-index: 1;\r\n    }\r\n\r\n\r\n    .location-input {\r\n        padding-left: 32px !important;\r\n        padding-right: 40px !important;\r\n    }\r\n\r\n\r\n    .root-btn {\r\n        position: absolute;\r\n        right: 8px;\r\n        background: none;\r\n        border: none;\r\n        color: #0066cc;\r\n        cursor: pointer;\r\n        padding: 4px;\r\n        border-radius: 4px;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        transition: all 0.2s;\r\n\r\n\r\n        &:hover {\r\n            background: #f0f8ff;\r\n            color: #0052a3;\r\n        }\r\n    }\r\n}\r\n\r\n\r\n// Upload section improvements\r\n.upload-section {\r\n    .file-input {\r\n        width: 100%;\r\n        padding: 10px 12px;\r\n        border: 2px dashed #ddd;\r\n        border-radius: 6px;\r\n        background: #fafafa;\r\n        cursor: pointer;\r\n        transition: all 0.2s;\r\n       \r\n        &:hover {\r\n            border-color: #0066cc;\r\n            background: #f8fbff;\r\n        }\r\n\r\n\r\n        &:disabled {\r\n            cursor: not-allowed;\r\n            opacity: 0.6;\r\n        }\r\n    }\r\n\r\n\r\n    .upload-progress {\r\n        margin-top: 12px;\r\n        padding: 12px;\r\n        background: #f8f9fa;\r\n        border-radius: 6px;\r\n        border: 1px solid #e9ecef;\r\n\r\n\r\n        .progress-bar {\r\n            width: 100%;\r\n            height: 8px;\r\n            background: #e9ecef;\r\n            border-radius: 4px;\r\n            overflow: hidden;\r\n            margin-bottom: 8px;\r\n\r\n\r\n            .progress {\r\n                height: 100%;\r\n                background: linear-gradient(90deg, #0066cc, #4a9eff);\r\n                border-radius: 4px;\r\n                transition: width 0.3s ease;\r\n            }\r\n        }\r\n\r\n\r\n        span {\r\n            font-size: 12px;\r\n            color: #666;\r\n            font-weight: 500;\r\n        }\r\n    }\r\n\r\n\r\n    .uploaded-file-preview {\r\n        margin-top: 12px;\r\n        padding: 12px;\r\n        background: #f0f8ff;\r\n        border: 1px solid #cce7ff;\r\n        border-radius: 6px;\r\n\r\n\r\n        .file-info {\r\n            display: flex;\r\n            align-items: center;\r\n            gap: 8px;\r\n\r\n\r\n            svg {\r\n                color: #0066cc;\r\n                flex-shrink: 0;\r\n            }\r\n\r\n\r\n            span {\r\n                flex: 1;\r\n                font-size: 14px;\r\n                color: #333;\r\n                font-weight: 500;\r\n                overflow: hidden;\r\n                text-overflow: ellipsis;\r\n                white-space: nowrap;\r\n            }\r\n\r\n\r\n            .cancel-upload-button {\r\n                background: none;\r\n                border: none;\r\n                color: #dc2626;\r\n                font-size: 18px;\r\n                font-weight: bold;\r\n                cursor: pointer;\r\n                padding: 2px 6px;\r\n                border-radius: 4px;\r\n                transition: all 0.2s;\r\n                line-height: 1;\r\n\r\n\r\n                &:hover {\r\n                    background: #fee2e2;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n\r\n// Responsive adjustments for breadcrumb\r\n@media (max-width: 768px) {\r\n    .info-bar {\r\n        flex-direction: column;\r\n        gap: 8px;\r\n        align-items: flex-start;\r\n\r\n\r\n        .breadcrumb {\r\n            .breadcrumb-item {\r\n                font-size: 12px;\r\n                padding: 3px 6px;\r\n            }\r\n        }\r\n\r\n\r\n        .total-items {\r\n            font-size: 12px;\r\n        }\r\n    }\r\n\r\n\r\n    .location-input-container {\r\n        .location-input {\r\n            padding-left: 28px !important;\r\n            padding-right: 36px !important;\r\n        }\r\n\r\n\r\n        > svg {\r\n            left: 8px;\r\n            width: 14px;\r\n            height: 14px;\r\n        }\r\n\r\n\r\n        .root-btn {\r\n            right: 6px;\r\n            padding: 3px;\r\n\r\n\r\n            svg {\r\n                width: 12px;\r\n                height: 12px;\r\n            }\r\n        }\r\n    }\r\n\r\n\r\n    .upload-section {\r\n        .file-input {\r\n            padding: 8px 10px;\r\n            font-size: 14px;\r\n        }\r\n\r\n\r\n        .upload-progress {\r\n            padding: 10px;\r\n\r\n\r\n            .progress-bar {\r\n                height: 6px;\r\n            }\r\n\r\n\r\n            span {\r\n                font-size: 11px;\r\n            }\r\n        }\r\n\r\n\r\n        .uploaded-file-preview {\r\n            padding: 10px;\r\n\r\n\r\n            .file-info {\r\n                gap: 6px;\r\n\r\n\r\n                svg {\r\n                    width: 14px;\r\n                    height: 14px;\r\n                }\r\n\r\n\r\n                span {\r\n                    font-size: 13px;\r\n                }\r\n\r\n\r\n                .cancel-upload-button {\r\n                    font-size: 16px;\r\n                    padding: 1px 4px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
